export const state = () => ({
  notifications: [],
});

export const actions = {
  setNotifications({commit}) {
    this.$api("getNotifications", {}, "POST")
        .then(result => {
          let notifications = result.data
          notifications.forEach(notification => {
            if (notification.date) {
              let dateArray = notification.date.split('T')
              if (dateArray.length > 1) {
                notification.formattedDate = `${dateArray[0].split('-').reverse().join('.')} ${dateArray[1].slice(0, 5)}`
              } else {
                notification.formattedDate = `${dateArray[0].split('-').reverse().join('.')}`
              }
            }
          })
          commit('SET_NOTIFICATIONS', notifications);
        })
        .catch(error => {
          if (error.message === 'Не найдено элементов') {
            commit('SET_NOTIFICATIONS', []);
          }
        })
  },
  readNotification({commit}, id) {
    this.$api("setNotificationStatus", {id: id, status: 1}, "POST")
        .then(result => {
          if (result.data[0]) {
            commit('READ_NOTIFICATION', id);
          }
        })
  },
  add({commit}, value) {
    commit('ADD', value);
  },
  remove({commit}, index) {
    commit('REMOVE', index);
  }
};

export const mutations = {
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications;
  },
  READ_NOTIFICATION(state, id) {
    const selectedNotification = state.notifications.find(notification => notification.id === id)
    selectedNotification.status = 1
  },
  ADD(state, value) {
    state.list.push(value);
  },
  REMOVE(state, index) {
    state.list.splice(index, 1);
  }
};

export const getters = {
  getNotificationsCount: (state) => {
    const notReadNotifications = state.notifications.filter(notification => notification.status === '0')
    return notReadNotifications.length;
  },
  getNotifications: (state) => {
    return state.notifications;
  }
};
